import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';

import { AppRouteReuseStrategy } from './app-route-reuse.strategy';
import { AuthGuard } from './presentation/common/guard/auth.guard';
import { CoachProfileComponent } from './presentation/page/profile/coach-profile/coach-profile.component';
import { CoacheeProfileComponent } from './presentation/page/profile/coachee-profile/coachee-profile.component';

const routes: Routes = [
	{
		path: 'booth',
		loadChildren: () =>
			import('./presentation/page/coaching/booth.module').then(
				(m) => m.BoothModule
			),
	},
	{
		path: 'activity',
		loadChildren: () =>
			import('./presentation/page/coaching/activity.module').then(
				(m) => m.ActivityModule
			),
	},
	{
		path: 'answers',
		loadChildren: () =>
			import('./presentation/page/coaching/answers.module').then(
				(m) => m.AnswersModule
			),
	},
	{
		path: 'monitoring',
		loadChildren: () =>
			import('./presentation/page/coaching/monitoring.module').then(
				(m) => m.MonitoringModule
			),
	},
	{
		path: 'mosaic',
		loadChildren: () =>
			import('./presentation/page/coaching/mosaic.module').then(
				(m) => m.MosaicModule
			),
	},
	{
		path: 'kanban-networking',
		loadChildren: () =>
			import('presentation/page/coaching/kanban-networking.module').then(
				(m) => m.KanbanNetworkingModule
			),
	},
	{
		path: 'kanban-job-offer',
		loadChildren: () =>
			import('presentation/page/coaching/kanban-job-offer.module').then(
				(m) => m.KanbanJobOfferModule
			),
	},
	{
		path: 'home',
		loadChildren: () =>
			import('./presentation/page/home/home.module').then((m) => m.HomeModule),
	},
	{
		path: 'settings',
		loadChildren: () =>
			import('./presentation/page/settings/settings.module').then(
				(m) => m.SettingsModule
			),
	},
	{
		path: 'contact',
		loadChildren: () =>
			import('./presentation/page/contact/contact.module').then(
				(m) => m.ContactModule
			),
	},
	{
		path: 'library',
		loadChildren: () =>
			import('./presentation/page/library/library.module').then(
				(m) => m.LibraryModule
			),
	},
	{
		path: 'coachee/:id',
		canActivate: [AuthGuard],
		component: CoacheeProfileComponent,
		data: { showTitle: true, contextualChat: false },
	},
	{
		path: 'coach/:id',
		canActivate: [AuthGuard],
		component: CoachProfileComponent,
		data: { showTitle: true, contextualChat: false },
	},
	{
		path: '**',
		pathMatch: 'prefix',
		redirectTo: 'home',
	},
];

@NgModule({
	imports: [
		RouterModule.forRoot(routes, {
			paramsInheritanceStrategy: 'always',
			onSameUrlNavigation: 'reload',
		}),
	],
	providers: [{ provide: RouteReuseStrategy, useClass: AppRouteReuseStrategy }],
	exports: [RouterModule],
})
export class AppRoutingModule {}
